/**
 * @generated SignedSource<<1ab68d7461fcffbcea2d6d3fe9ea63af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateSiteInput = {
  clientMutationId?: string | null;
  siteId: string;
  name?: string | null;
  url?: string | null;
};
export type SiteEditFormContainer_Mutation$variables = {
  input: UpdateSiteInput;
};
export type SiteEditFormContainer_MutationVariables = SiteEditFormContainer_Mutation$variables;
export type SiteEditFormContainer_Mutation$data = {
  readonly updateSite: {
    readonly site: {
      readonly id: string;
      readonly name: string;
      readonly url: string;
      readonly slug: string;
    } | null;
  } | null;
};
export type SiteEditFormContainer_MutationResponse = SiteEditFormContainer_Mutation$data;
export type SiteEditFormContainer_Mutation = {
  variables: SiteEditFormContainer_MutationVariables;
  response: SiteEditFormContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateSitePayload",
    "kind": "LinkedField",
    "name": "updateSite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SiteEditFormContainer_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SiteEditFormContainer_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5a7936dbfed7eb050e8bb78ce56221aa",
    "id": null,
    "metadata": {},
    "name": "SiteEditFormContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation SiteEditFormContainer_Mutation(\n  $input: UpdateSiteInput!\n) {\n  updateSite(input: $input) {\n    site {\n      id\n      name\n      url\n      slug\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d8fd92628a4b32aca603382c29bf914f";

export default node;
